// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamWithData__root--A4Sjl"};